/* ========================================================================
 * Core
 * ======================================================================== */

/**
 * PictureFill + LazySizes + WOW
 *
 * NOTE: You should not need to modify
 * this file!
 *
 * The libraries listed below are used in almost ALL DOD projects.
 */

/**
 * Responsive Images Polyfill
 */
import 'picturefill';
/**
 * Lazyload images:
 * @see https://github.com/aFarkas/lazysizes
 */
import 'lazysizes';

document.addEventListener('lazyloaded', function (e) {
    if (e.target.closest('.js-lazyload-wrapper')) {
        e.target
            .closest('.js-lazyload-wrapper')
            .classList.add('js-lazyload-wrapper-loaded');
    }
});
